import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Utils } from '../../utils';
import logo from '../../assets/notifysphere-logo.png';
import eyeOpenImg from '../../assets/icons/eye.png';
import eyeCloseImg from '../../assets/icons/invisible.png';

const AdminResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setError('Invalid reset link. Please use the link from your email.');
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!token) return;
        if (newPassword.length < 6) {
            setError('New password must be at least 6 characters');
            return;
        }
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(Utils.baseurl + 'admin/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword })
            });
            const result = await response.json();

            if (result.status) {
                setSuccess(result.message || 'Password reset successfully. Redirecting to login...');
                setTimeout(() => navigate('/admin/login'), 2000);
            } else {
                setError(result.message || 'Invalid or expired link. Please request a new reset link.');
            }
        } catch (err) {
            setError('Connection error. Please try again.');
        }
        setLoading(false);
    };

    if (!token) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                <div style={{ background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', width: '100%', maxWidth: '400px' }}>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                        <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
                        <h2 style={{ margin: 0, color: '#1a1a1a' }}>Invalid link</h2>
                        <p style={{ color: '#dc2626', marginTop: '12px' }}>Invalid reset link. Please use the link from your email or request a new one.</p>
                    </div>
                    <button
                        type="button"
                        onClick={() => navigate('/admin/forgot-password')}
                        style={{
                            width: '100%', padding: '14px', background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                            color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer'
                        }}
                    >
                        Request reset link
                    </button>
                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <button type="button" onClick={() => navigate('/admin/login')} style={{ background: 'none', border: 'none', color: '#4f46e5', fontSize: '14px', cursor: 'pointer', textDecoration: 'underline' }}>
                            Back to Sign in
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <div style={{ background: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', width: '100%', maxWidth: '400px' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
                    <h2 style={{ margin: 0, color: '#1a1a1a' }}>Set new password</h2>
                    <p style={{ color: '#6b7280', marginTop: '8px' }}>Enter your new password below</p>
                </div>

                {error && (
                    <div style={{ background: '#fee2e2', color: '#dc2626', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px' }}>
                        {error}
                    </div>
                )}
                {success && (
                    <div style={{ background: '#d1fae5', color: '#059669', padding: '12px', borderRadius: '8px', marginBottom: '20px', fontSize: '14px' }}>
                        {success}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>New password (min 6 characters)</label>
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                style={{ width: '100%', padding: '12px 40px 12px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                required
                                minLength={6}
                            />
                            <img
                                src={showNewPassword ? eyeCloseImg : eyeOpenImg}
                                alt="Toggle"
                                onClick={() => setShowNewPassword(!showNewPassword)}
                                style={{ position: 'absolute', right: '12px', width: 18, height: 18, cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>Confirm new password</label>
                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                style={{ width: '100%', padding: '12px 40px 12px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                required
                                minLength={6}
                            />
                            <img
                                src={showConfirmPassword ? eyeCloseImg : eyeOpenImg}
                                alt="Toggle"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                style={{ position: 'absolute', right: '12px', width: 18, height: 18, cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%', padding: '14px', background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                            color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600',
                            cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1
                        }}
                    >
                        {loading ? 'Updating...' : 'Reset password'}
                    </button>

                    <div style={{ marginTop: '20px', textAlign: 'center' }}>
                        <button
                            type="button"
                            onClick={() => navigate('/admin/login')}
                            style={{
                                background: 'none', border: 'none', color: '#4f46e5', fontSize: '14px',
                                cursor: 'pointer', textDecoration: 'underline', padding: 0
                            }}
                        >
                            Back to Sign in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminResetPassword;
